import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "Como funciona a detecção de vazamentos sem quebrar?",
    answer: "Utilizamos equipamentos eletrônicos de alta tecnologia como geofone eletrônico, correlacionador acústico e termografia infravermelha. Esses aparelhos identificam o som e a temperatura do vazamento, permitindo uma localização extremamente precisa. Assim, só quebramos o necessário para o reparo, preservando sua estrutura."
  },
  {
    question: "Quanto tempo leva para detectar um vazamento?",
    answer: "O tempo varia de acordo com a complexidade e o tamanho da área. Em média, a detecção leva entre 1 a 3 horas. Em casos mais simples, podemos identificar em menos de 1 hora. Em casos complexos ou grandes áreas, pode levar um pouco mais. Sempre trabalhamos com eficiência para resolver seu problema o mais rápido possível."
  },
  {
    question: "Vocês fazem o reparo também ou só a detecção?",
    answer: "Fazemos o serviço completo! Além da detecção precisa, executamos todo o reparo com nossa equipe própria especializada. Isso inclui quebra pontual (apenas onde necessário), troca de tubulações, impermeabilização e acabamento. Você não precisa contratar outra empresa."
  },
  {
    question: "O serviço tem garantia?",
    answer: "Sim! Todos os nossos serviços possuem garantia. Para detecção e reparo de vazamentos, oferecemos 12 meses de garantia. Se o problema voltar no mesmo local dentro deste período, voltamos sem custo adicional. Sua tranquilidade é nossa prioridade."
  },
  {
    question: "Atendem emergências e fora do horário comercial?",
    answer: "Sim! Temos atendimento 24 horas para casos de emergência. Sabemos que vazamentos podem acontecer a qualquer momento e causar grandes prejuízos. Entre em contato pelo WhatsApp (11) 94894-8561 a qualquer hora, inclusive finais de semana e feriados."
  },
  {
    question: "Como é feito o orçamento? É pago?",
    answer: "Fazemos uma visita técnica totalmente gratuita e sem compromisso. Nossa equipe vai até seu local, avalia a situação, identifica o problema e apresenta um orçamento claro e transparente. Você só paga se aprovar e decidir contratar o serviço. Sem pegadinhas ou custos ocultos."
  },
  {
    question: "Emitem nota fiscal e ART?",
    answer: "Sim! Somos uma empresa 100% regularizada. Emitimos nota fiscal de todos os serviços e, quando necessário (perícias, seguros, condomínios), fornecemos a ART - Anotação de Responsabilidade Técnica registrada no CREA, com validade legal em todo território nacional."
  },
  {
    question: "Atendem condomínios e empresas?",
    answer: "Sim! Temos vasta experiência em atendimento a condomínios residenciais, comerciais e empresas. Fornecemos relatórios técnicos detalhados, laudos com ART, e trabalhamos com discrição e profissionalismo para não atrapalhar a rotina dos moradores ou funcionários."
  }
];

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleContactClick = () => {
    const whatsappUrl = "https://wa.me/5511948948561?text=Olá! Tenho algumas dúvidas sobre os serviços de caça vazamentos.";
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 animate-fade-in">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              ❓ Dúvidas Frequentes
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Respondemos as principais perguntas sobre nossos serviços
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-4 mb-12">
            {faqData.map((faq, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden transition-all duration-300 hover:shadow-lg"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-slate-50 transition-colors duration-200"
                >
                  <h3 className="text-lg font-semibold text-slate-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className={`w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}>
                    <i className="ri-arrow-down-s-line text-xl text-blue-600"></i>
                  </div>
                </button>
                
                <div className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-6 pb-5">
                    <div className="border-t border-slate-200 pt-4">
                      <p className="text-slate-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-slate-200">
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-slate-900 mb-2">
                  Ainda Tem Dúvidas?
                </h3>
                <p className="text-slate-600">
                  Nossa equipe está pronta para esclarecer todas as suas questões
                </p>
              </div>
              
              <button
                onClick={handleContactClick}
                className="inline-flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Fale Conosco no WhatsApp
              </button>
              
              <p className="text-sm text-slate-500 mt-4">
                Resposta rápida e atendimento personalizado
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}